import { InjectedContentBlock } from "@omni/types/api/search/bff/injectedContentBlock.model";
import { AdvisorMode } from "@omni/types/components/aiden/advisorMode.enum";
import { cn } from "@omni/utils/styles";

import { ContentBlockComponent } from "./contentBlock.component";
import { ContentBlockButton } from "./contentBlockButton.component";
import { ContentBlockLink } from "./contentBlockLink.component";

type ContentBlockComponentProps = {
    content: InjectedContentBlock;
};

const ContentBlock = ({ content }: ContentBlockComponentProps) => {
    const expandImage = !!(
        content.imageUrl &&
        !content.title &&
        !content.description
    );

    const className = cn(
        "tw:shadow-card tw:rounded-md tw:border-none tw:transition-transform tw:h-full tw:flex tw:flex-col tw:justify-start",
        "tw:hover:shadow-card-active tw:hover:scale-102",
        {
            "tw:p-4": !expandImage
        }
    );

    return content.aidenAdvisorId ? (
        <ContentBlockButton
            className={className}
            data-advisor-id={content.aidenAdvisorId}
            data-aiden-mode={
                content.aidenAdvisorMode === AdvisorMode.Ai
                    ? "ai-sidebar"
                    : "sidebar"
            }
        >
            <ContentBlockComponent
                content={content}
                expandImage={expandImage}
            />
        </ContentBlockButton>
    ) : (
        <ContentBlockLink
            className={className}
            url={content.url}
        >
            <ContentBlockComponent
                content={content}
                expandImage={expandImage}
            />
        </ContentBlockLink>
    );
};

export { ContentBlock };
